export const TECHNICIAN_NOTE_TEXTAREA_HEIGHT = '120px';

export const formatTechnicianNoteMeta = (author, date) =>
  [author, date].filter(Boolean).join(' | ');

export const cloneTechnicianNoteItems = (items = []) =>
  items.map(({ note, author, date }) => ({ note, author, date }));

export const hasValidTechnicianNotes = (items = []) =>
  items.some((item) => item.note?.trim());

export const hasEmptyTechnicianNote = (items = []) =>
  items.some((item) => !item.note?.trim());

export const buildTechnicianNoteItemsPayload = (items = [], { allNew = false } = {}) =>
  items
    .filter((item) => item.note?.trim())
    .map((item) => {
      if (allNew || item.is_new) {
        return { note: item.note.trim(), is_new: true };
      }
      const payload = { note: item.note.trim() };
      if (item.author) payload.author = item.author;
      if (item.date) payload.date = item.date;
      return payload;
    });

export const areTechnicianNotesEqual = (a = [], b = []) =>
  JSON.stringify(cloneTechnicianNoteItems(a)) === JSON.stringify(cloneTechnicianNoteItems(b));
